import { Controller } from '@hotwired/stimulus';
import Coloris from '@melloware/coloris';

export default class extends Controller {
  static values = {
    format: { type: String, default: 'mixed' },
    alpha: { type: Boolean, default: true }
  };

  connect() {
    this.parent = this.element.closest('dialog') || this.element.parentElement;
    this.positionedParent = false;
    if (window.getComputedStyle(this.parent).position === 'static') {
      this.originalParentPosition = this.parent.style.position;
      this.parent.style.position = 'relative';
      this.positionedParent = true;
    }

    this.dialog = this.element.closest('dialog');
    if (this.dialog) {
      // Coloris stops mousedown propagation. Capture it before the picker so
      // a drag released outside the picker is not treated as a backdrop click.
      this.trackPickerPress = (event) => {
        this.pressedInPicker = Boolean(event.target.closest('.clr-picker'));
      };
      this.keepPickerDragInsideDialog = (event) => {
        const pressedInPicker = this.pressedInPicker;
        this.pressedInPicker = false;
        if (pressedInPicker && !event.target.closest('.clr-picker')) event.stopPropagation();
      };
      this.dialog.addEventListener('mousedown', this.trackPickerPress, true);
      this.dialog.addEventListener('click', this.keepPickerDragInsideDialog, true);
    }

    Coloris.init();
    Coloris({
      el: this.element,
      format: this.formatValue,
      alpha: this.alphaValue,
      theme: 'polaroid',
      parent: this.parent,
      inline: false,
      defaultColor: '#666666'
    });
  }

  disconnect() {
    this.dialog?.removeEventListener('mousedown', this.trackPickerPress, true);
    this.dialog?.removeEventListener('click', this.keepPickerDragInsideDialog, true);
    if (this.positionedParent) this.parent.style.position = this.originalParentPosition;
  }
}
